export enum EntityType {
    CONTENT = 'CONTENT',
    COURSE = 'COURSE',
    LIST = 'LIST',
    PROGRAM = 'PROGRAM',
    WORKSHOP = 'WORKSHOP',
}
